<template>
  <div>
    <b-modal id="referral-modal" centered title="Refer a Friend" hide-footer>
      <p v-if="subscribed">Refer a friend get $10 and give $10 when they upgrade to a paid plan.</p>
      <validation-observer v-slot="{ invalid }" ref="formValidator">
        <form class="needs-validation" ref="economicModelForm"
              @submit.prevent="finalize">
          <base-input label="First Name:"
                      label-for="first_name"
                      name="First Name"
                      rules="required"
                      v-model="form.first_name">
          </base-input>
          <base-input label="Last Name:"
                      label-for="last_name"
                      name="Last Name"
                      rules="required"
                      v-model="form.last_name">
          </base-input>
          <base-input label="Email:"
                      label-for="email"
                      name="Email"
                      type="email"
                      rules="required"
                      v-model="form.email">
          </base-input>
          <b-button block variant="danger" type="submit" :disabled="disabled">Submit</b-button>
        </form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { mapGetters } from 'vuex';

export default {
  mixins: [errorsMixin],
  data() {
    return {
      validated: false,
      form: {
        first_name: '',
        last_name: '',
        email: ''
      },
      disabled: false,
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium',
    }),
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
    referralValue() {
      return this.subscribed ? 10 : 0;
    }
  },
  methods: {
    async finalize() {
      this.disabled = true;
      await axios.post(this.userRoute + "/referrals", {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        email: this.form.email,
        value: this.referralValue
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.disabled = false;
          this.$bvModal.hide('referral-modal');
          this.clearForm();
        });
      })
      .catch(error => {
        this.error(error);
        this.disabled = false;
      });
    },
    clearForm() {
      this.form.first_name = '';
      this.form.last_name = '';
      this.form.email = '';
      this.form.value = 0;
    }
  }
};
</script>